import { Icon } from "@iconify/react";
import LinkNext from "next/link";
import { twMerge } from "tailwind-merge";

const SocialMedia = ({ facebook, instagram, twitter, className = "" }) => {
  return (
    <div
      className={twMerge(
        "flex flex-row items-center justify-center mb-10 xl:mb-0",
        className
      )}
    >
      {instagram ? (
        <LinkNext href={instagram}>
          <a
            target="_blank"
            aria-label="Instagram"
            className="mx-2 border-2 border-[#FFFFFF55] rounded-[8px] w-8 h-8 flex items-center justify-center"
          >
            <Icon icon="ant-design:instagram-filled" width={24} height={24} />
          </a>
        </LinkNext>
      ) : null}
      {facebook ? (
        <LinkNext href={facebook}>
          <a
            target="_blank"
            aria-label="Facebook"
            className="mx-2 border-2 border-[#FFFFFF55] rounded-[8px] w-8 h-8 flex items-center justify-center"
          >
            <Icon icon="brandico:facebook" width={18} height={18} />
          </a>
        </LinkNext>
      ) : null}
      {twitter ? (
        <LinkNext href={twitter}>
          <a
            target="_blank"
            aria-label="Twitter"
            className="mx-2 border-2 border-[#FFFFFF55] rounded-[8px] w-8 h-8 flex items-center justify-center"
          >
            <Icon icon="ri:twitter-x-fill" />
          </a>
        </LinkNext>
      ) : null}
    </div>
  );
};

export default SocialMedia;
